import { render, staticRenderFns } from "./VChargeForm.vue?vue&type=template&id=734a9ca2&"
import script from "./VChargeForm.vue?vue&type=script&lang=js&"
export * from "./VChargeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports